<template>
    <div id="app">
        <PageHeader class="header"/>
        <main :class="{faded}">
            <transition mode="out-in" name="fade">
                <router-view></router-view>
            </transition>
        </main>
        <PageNavigation/>
    </div>
</template>
<script>
    import 'firebase/auth';
    import PageHeader from './components/PageHeader';
    import {setFadeOutListener, setOnAuthReadyListener} from './other/page-global';
    import PageNavigation from './components/PageNavigation';

    export default {
        name: 'App',
        components: {PageNavigation, PageHeader},
        created() {
            setFadeOutListener(this.onFadeOut.bind(this));
            setOnAuthReadyListener(() => {
                this.onFadeOut(false);
            });
        },
        data() {
            return {
                faded: true,
                ready: false,
            };
        },
        methods: {
            onFadeOut(faded) {
                this.faded = faded;
            },
        }
    };
</script>
<!--suppress CssUnusedSymbol, CssNoGenericFontName -->
<style>
    body {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        color: #EEE;
        margin: 0;
        padding: 0;
        background: #05121d;
        user-select: none;
        font-family: Roboto, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        -webkit-tap-highlight-color: transparent;
        overflow: hidden;
    }

    #app {
        display: grid;
        margin: 0 auto;
        /*max-width: 1000px;*/
        width: 100%;
        max-height: 100%;
        height: 100%;
        overflow: hidden;
        grid-template-areas: 'header' 'main' 'nav';
        grid-template-rows: 48px auto 52px;
        grid-template-columns: auto;
    }

    main {
        background: #051e34;
        transition: opacity .3s;
        overflow: auto;
        grid-area: main;
    }

    header {
        grid-area: header;
    }

    nav {
        grid-area: nav;
    }

    @media screen and (min-width: 500px) {
        #app {
            grid-template-areas:
                    'header header'
                    'nav main';
            grid-template-rows: 48px auto;
            grid-template-columns: minmax(80px, 12vw) auto;
        }
    }

    a, label {
        outline: 0;
    }

    a:active, label:active {
        background: initial;
    }

    /*noinspection ALL*/
    .faded {
        pointer-events: none;
        opacity: 0;
    }


    @keyframes FadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @media screen and (max-width: 600px) and (prefers-reduced-motion: no-preference) {
        .fade-leave-to {
            opacity: 0;
        }

        .fade-enter {
            opacity: 0;
            transform: translateY(.5em);
        }

        .fade-enter-active, .fade-leave-active {
            transition: opacity .2s ease, transform .2s ease;
        }
    }

    @media (prefers-reduced-motion: no-preference) {
        @keyframes DialogOpenAnimation {
            from {
                opacity: 0;
                transform: translateY(2rem);
            }

            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
    }

</style>
